import { useEffect, useState } from 'react'
import { TrailingInputCSS } from './TrailingInputCSS.styled'
import { onlyDigits } from 'utils/uiUtils_TS'
import { StateSlider } from '../StateSlider'
import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'

const INITIAL_VALUE = {
  trailingStopValue: '',
  trailingStopPercent: '',
}

const TRAILING_TYPES = [
  { name: 'Amount', value: 'amount' },
  { name: 'Percentage', value: 'percentage' },
  // { name: 'Both', value: 'both' },
]

export const TrailingInputs = ({ onChange, reset }) => {
  const [value, setValues] = useState(INITIAL_VALUE)
  const [sliderSelection, setSliderSelection] = useState(TRAILING_TYPES.at(0))

  useEffect(() => {
    if (reset) setValues(INITIAL_VALUE)
  }, [reset])

  const onInputChange = (e) => {
    const inputName = e.target.name
    const inputValue = onlyDigits(e.target.value)
    setValues((prev) => {
      if (inputName === 'trailingStopPercent' && inputValue > 100) return prev
      const newValue = { ...prev, [inputName]: inputValue }
      onChange && onChange(newValue)
      return newValue
    })
  }

  const onSelection = (selection) => {
    setValues(INITIAL_VALUE)
    setSliderSelection(selection)
  }

  return (
    <TrailingInputCSS>
      {
        <div id='trailing_inputs_container'>
          <fieldset>
            <StateSlider stateOptions={TRAILING_TYPES} title={'Close Bid with trailing stop'} onSelection={onSelection} />
            <ContentSwitcherByState noWrapper activeState={sliderSelection?.value} stateObject={{

              amount: (
                <input
                  type='text'
                  name='trailingStopValue'
                  className='trailing amount'
                  placeholder='Trailing stop amount'
                  value={value.trailingStopValue}
                  onChange={onInputChange}
                />),
              percentage: (
                <input
                  type='text'
                  name='trailingStopPercent'
                  className='trailing percentage'
                  placeholder='Trailing stop percent'
                  value={value.trailingStopPercent}
                  onChange={onInputChange}
                />
              ),
            }} />
          </fieldset>
          {/* <fieldset>
            <strong style={{ color: 'transparent' }}>Percentage</strong>
          </fieldset> */}
        </div>
        // </div>
      }
    </TrailingInputCSS>
  )
}
